'use client'
import { PrismicImage, PrismicRichText } from "@prismicio/react";
import { isFilled } from "@prismicio/client";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import '@splidejs/react-splide/css/core';


/**
 * @typedef {import("@prismicio/client").Content.LogoCardCarouselSlice} LogoCardCarouselSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<LogoCardCarouselSlice>} LogoCardCarouselProps
 * @type {import("react").FC<LogoCardCarouselProps>}
 */

const Card = ({ item, idx }) => (
  <div
    key={idx}
    className="bg-light-gray rounded-2xl p-5 lg:pr-10 py-6 flex flex-col h-full gap-6"
  >
    {isFilled.image(item.img) && (
      <PrismicImage
        field={item.img}
        className="w-24 h-auto object-contain"
      />
    )}
    <div className="flex flex-col gap-4">
      {isFilled.richText(item.title) && (
        <PrismicRichText
          field={item.title}
          components={{
            heading3: ({ children }) => <h3 className="h3-sm">{children}</h3>,
            heading4: ({ children }) => <h4 className="h3-sm">{children}</h4>,
            heading5: ({ children }) => <h5 className="h3-sm">{children}</h5>,
          }}
        />
      )}
      {isFilled.richText(item.description) && (
        <PrismicRichText field={item.description}
          components={{
            paragraph: ({ children }) => <p className="">{children}</p>,

          }} />
      )}
    </div>
  </div>
);


const LogoCardCarousel = ({ slice }) => {
  const { title, cards } = slice.primary;
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className="framing mt-15 mb-25 overflow-hidden bg-white text-dark-green"
    >
      <div className="flex flex-col gap-5">
        {isFilled.richText(title) && (
          <PrismicRichText
            field={title}
            components={{
              heading2: ({ children }) => (
                <h2 className="h3-sm">
                  {children}
                </h2>
              ),
              heading3: ({ children }) => (
                <h3 className="h3-sm">
                  {children}
                </h3>
              ),
              heading4: ({ children }) => (
                <h4 className="h3-sm">
                  {children}
                </h4>
              ),
            }}
          />
        )}
        {(isFilled.group(cards) && cards.length > 2) ? (
          <Splide
            options={{
              type: "loop",
              perPage: 2,
              perMove: 1,
              gap: "2.5rem",
              arrows: true,
              pagination: false,
              speed: 800,
              breakpoints: {
                768: {
                  perPage: 1,
                  arrows: false,
                  pagination: true,
                },
              },
            }}
          >
            {cards.map((card, idx) => (
              <SplideSlide key={idx}>
                <Card item={card} idx={idx} />
              </SplideSlide>
            ))}
          </Splide>
        ) : <div className="">
          <div className="hidden md:flex gap-10">
            {
              cards.map((card, idx) => (
                <Card key={idx} item={card} idx={idx} />
              ))
            }
          </div>
          <div className="md:hidden">
            <Splide
              options={{
                type: "loop",
                perPage: 1,
                perMove: 1,
                gap: "2.5rem",
                arrows: false,
                pagination: true,
                speed: 800,
              }}
            >
              {cards.map((card, idx) => (
                <SplideSlide key={idx}>
                  <Card item={card} idx={idx} />
                </SplideSlide>
              ))}
            </Splide>
          </div>
        </div>
        }
      </div>
    </section>
  );
};

export default LogoCardCarousel;
